"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Properties = void 0;
const propertiesGetPropertyDetailsPropertiesStreetGroupPropertyIdGet_js_1 = require("../funcs/propertiesGetPropertyDetailsPropertiesStreetGroupPropertyIdGet.js");
const propertiesPostAddressMatchPropertiesAddressMatchPost_js_1 = require("../funcs/propertiesPostAddressMatchPropertiesAddressMatchPost.js");
const propertiesPostAddressMatchV2ExactPropertiesAddressMatchV2ExactPost_js_1 = require("../funcs/propertiesPostAddressMatchV2ExactPropertiesAddressMatchV2ExactPost.js");
const propertiesPostAddressMatchV2LlmPropertiesAddressMatchV2LlmPost_js_1 = require("../funcs/propertiesPostAddressMatchV2LlmPropertiesAddressMatchV2LlmPost.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class Properties extends sdks_js_1.ClientSDK {
    /**
     * Get Property Details
     *
     * @remarks
     * Get property details for a property using the `street_group_property_id`.
     *
     * - A `fields[property]` parameter can be passed to return a subset of the property attributes in the response.
     */
    async getPropertyDetailsPropertiesStreetGroupPropertyIdGet(security, fieldsProperty, streetGroupPropertyId, options) {
        return (0, fp_js_1.unwrapAsync)((0, propertiesGetPropertyDetailsPropertiesStreetGroupPropertyIdGet_js_1.propertiesGetPropertyDetailsPropertiesStreetGroupPropertyIdGet)(this, security, fieldsProperty, streetGroupPropertyId, options));
    }
    /**
     * Post Address Match
     *
     * @remarks
     * Get details of a property using a user provided address string & postcode.
     *
     * - This endpoint is functionally equivalent to [Get Property Details](#tag/properties/GET/properties/{street_group_property_id}) except a request body is sent
     * containing a user address string and a postcode.
     * -  The corresponding `street_group_property_id` will be looked up and the property fields are returned using the `street_group_property_id`.
     * -  A `fields[property]` parameter can be passed to return a subset of property attributes in the response.
     *
     * ### 429 Too Many Requests
     *
     * <details>
     * <summary>Click to view information on handling HTTP 429s when using this endpoint</summary>
     *
     * There is a limit set to how many requests to this endpoint can be made in a given minute. This endpoint can return
     * a 429 if this limit is reached and is shared across all users of Kraken. The current limit for each versions is as follows:
     *
     * V1: `6000/minute`
     *
     * While it's not common to hit this limit you should implement a retry with increasing delay intervals to handle
     * a 429 response.
     *
     * </details>
     */
    async postAddressMatchPropertiesAddressMatchPost(security, addressMatchPostRequest, fieldsProperty, confidence, format, options) {
        return (0, fp_js_1.unwrapAsync)((0, propertiesPostAddressMatchPropertiesAddressMatchPost_js_1.propertiesPostAddressMatchPropertiesAddressMatchPost)(this, security, addressMatchPostRequest, fieldsProperty, confidence, format, options));
    }
    /**
     * Post Address Match v2
     *
     * @remarks
     * Get details of a property using a user provided address string & postcode.
     *
     * - This endpoint is functionally equivalent to [Get Property Details](#tag/properties/GET/properties/{street_group_property_id}) except a request body is sent
     * containing a user address string and a postcode.
     * -  The corresponding `street_group_property_id` will be looked up and the property fields are returned using the `street_group_property_id`.
     * -  A `fields[property]` parameter can be passed to return a subset of property attributes in the response.
     *
     * ### 429 Too Many Requests
     *
     * <details>
     * <summary>Click to view information on handling HTTP 429s when using this endpoint</summary>
     *
     * There is a limit set to how many requests to this endpoint can be made in a given minute. This endpoint can return
     * a 429 if this limit is reached and is shared across all users of Kraken. The current limit is
     * `800000/minute`.
     *
     * While it's not common to hit this limit you should implement a retry with increasing delay intervals to handle
     * a 429 response.
     *
     * </details>
     *
     * @deprecated method: This will be removed in a future release, please migrate away from it as soon as possible.
     */
    async postAddressMatchV2ExactPropertiesAddressMatchV2ExactPost(security, addressMatchPostRequest, fieldsProperty, options) {
        return (0, fp_js_1.unwrapAsync)((0, propertiesPostAddressMatchV2ExactPropertiesAddressMatchV2ExactPost_js_1.propertiesPostAddressMatchV2ExactPropertiesAddressMatchV2ExactPost)(this, security, addressMatchPostRequest, fieldsProperty, options));
    }
    /**
     * Post Address Match v2 LLM
     *
     * @remarks
     * Get the `street_group_property_id` of a property using a user provided address string & postcode.
     *
     * - This endpoint uses an LLM to get the street group property ID based on the address string and postcode.
     * - This endpoint should be used only if [Post Address Match V2](#tag/properties/POST/properties/address-match-v2-exact) fails to return a result.
     * - This endpoint uses an external LLM and can take longer to respond than other address match endpoints.
     * - There is a cost to the business for each request made to this endpoint.
     * - This endpoint does not return property attributes. Only the `street_group_property_id` is returned.
     *
     * ### 429 Too Many Requests
     *
     * <details>
     * <summary>Click to view information on handling HTTP 429s when using this endpoint</summary>
     *
     * There is a limit set to how many requests to this endpoint can be made in a given minute. This endpoint can return
     * a 429 if this limit is reached and is shared across all users of Kraken. The current limit is
     * `6000/minute`.
     *
     * While it's not common to hit this limit you should implement a retry with increasing delay intervals to handle
     * a 429 response.
     *
     * </details>
     *
     * @deprecated method: This will be removed in a future release, please migrate away from it as soon as possible.
     */
    async postAddressMatchV2LlmPropertiesAddressMatchV2LlmPost(security, addressMatchPostRequest, fieldsProperty, options) {
        return (0, fp_js_1.unwrapAsync)((0, propertiesPostAddressMatchV2LlmPropertiesAddressMatchV2LlmPost_js_1.propertiesPostAddressMatchV2LlmPropertiesAddressMatchV2LlmPost)(this, security, addressMatchPostRequest, fieldsProperty, options));
    }
}
exports.Properties = Properties;
//# sourceMappingURL=properties.js.map